import { Component, uiElement, uiEvent } from "@kluntje/core";
import NavigationService from "Services/NavigationService";

export class WECHeader extends Component {
  @uiElement(".wec-m-header__navigation-toggle")
  navToggleBtn: HTMLButtonElement;

  @uiEvent("navToggleBtn", "click")
  handleNavToggleClick() {
    NavigationService.openNavigation();
  }
}

customElements.define("wec-m-header", WECHeader);
